/**
 * Legal step — agreement templates download from public/templates/.
 * agreementType derivation is FE-mock for now; prefer API when available.
 */

import { TEMPLATE_FILES, templateHref } from '../templateFile';

export type SiteType = 'CUSTOMER_FACING' | 'ISS_INTERNAL';

export type AgreementType = 'POC_AGREEMENT' | 'TRI_PARTY_AGREEMENT';

export function deriveAgreementType(
  siteType: SiteType | undefined | null
): AgreementType | null {
  if (siteType === 'ISS_INTERNAL') return 'POC_AGREEMENT';
  if (siteType === 'CUSTOMER_FACING') return 'TRI_PARTY_AGREEMENT';
  return null;
}

export function agreementTypeLabel(type: AgreementType): string {
  return type === 'POC_AGREEMENT' ? 'PoC Agreement' : 'Tri-Party Agreement';
}

/** Local copies in public/templates/ — click downloads. Legal Director still pending. */
export const LEGAL_LINKS = {
  pocAgreement: {
    label: 'PoC Agreement (country/group)',
    href: templateHref(TEMPLATE_FILES.pocAgreement),
  },
  triPartyAgreement: {
    label: 'Tri-Party Agreement (country/group)',
    href: templateHref(TEMPLATE_FILES.triParty),
  },
  contractCover: {
    label: 'Contract Cover',
    href: templateHref(TEMPLATE_FILES.contractCover),
  },
  responsibleLegalDirector: {
    label: 'Responsible Legal Director (Country or Group)',
    href: '#',
  },
} as const;
